import { all, takeLatest } from 'redux-saga/effects'

import { closeSelectedActionSaga } from './sagas/close-selected-action.saga'
import { patchSelectedRequestSaga } from './sagas/patch-selected-request.saga'
import { actionTypes } from './actions'

export function* missionsWatchSaga() {
  yield all([
    takeLatest(actionTypes.CLOSE_SELECTED_REQUEST, closeSelectedActionSaga),
    takeLatest(actionTypes.PATCH_SELECTED_REQUEST, patchSelectedRequestSaga),
  ])
}
